<script>
import {getEntriesList} from "@/assets/api";
import {nextTick} from "vue";

export default {
  name: "Recommended",
  data() {
    return {
      goods: [],
      pageNo: 1,
      pageSize: 16,
      total: 0,
      keyword: null
    }
  },
  created() {
   this.getList()
  },
  methods: {
    getList() {
      this.$axios.get(getEntriesList + `?pageSize=${this.pageSize}&pageNo=${this.pageNo}`).then(res => {
        if (res.data.success) {
          // 过滤掉审核未通过(3)和待审核(1)的产品，只显示审核通过(2)的
          let records = res.data.result.records || [];
          records = records.filter(item => String(item.status) === '2');
          // 中文页面：过滤掉中文标题和内容都为空的产品
          if (this.$language === 'ZH') {
            records = records.filter(item => {
              const titleCn = (item.titleCn || '').trim();
              const briefCn = (item.briefCn || '').trim();
              const descriptionCn = (item.descriptionCn || '').trim();
              return titleCn || briefCn || descriptionCn;
            });
          }
          this.goods = records;
          this.total = res.data.result.total
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    async handlePageChange(pageNo, pageSize) {
      await nextTick(() => {
        this.pageNo = pageNo
      })
      this.getList()
    },
  }
}
</script>

<template>
  <div style="width: 1200px;min-height: 600px;height: auto;margin: 104px auto 10px;padding-top: 30px;">
    <Breadcrumb :value="[$t('h.tabName1'),$t('h.custom.FeaturedExhibits'),$t('h.custom.ExhibitRecommendation')]"/>
    <div
        style="width: 100%;height: auto;display: flex;flex-wrap: wrap;margin-top: 20px;">
      <div v-for='(item) in goods' :key='item.id' style="width: 24.5%;margin-right: 0.5%;margin-bottom: 0.5%;">
        <div style="width: 100%;height: 100%;border: 1px solid #D8D8D8;padding: 24px 12px;"
             class="flex flex-column">
          <div style="font-size: 14px;color: #000000;padding-bottom: 12px;text-align: center;">{{ item.titleCn }}</div>
          <img object-fit="cover" :src="item.imageUrl" style="width: 100%;height: 160px;border-radius: 6px;"/>
        </div>
      </div>
    </div>
    <div style="margin-top: 40px;text-align: center;">
      <a-pagination v-model="pageNo" :pageSize="pageSize" :total="total" show-less-items
                    class="myPagination"
                    hideOnSinglePage @change="handlePageChange"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.myPagination {
  ::v-deep .ant-pagination-item-active {
    border-color: #F0831E;
    background-color: #F0831E;

    a {
      color: #fff;
    }
  }
}
</style>
